import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Typewriter } from 'react-simple-typewriter';
import emailjs from '@emailjs/browser';

import hero1 from '../images_sj/hero21.jpg';
import hero2 from '../images_sj/hero22.jpg';
import hero3 from '../images_sj/hero23.jpg';
import './headerCarousel.css';

const HeaderCarousel = () => {
  const [isFormExpanded, setIsFormExpanded] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const toggleForm = () => {
    setIsFormExpanded(!isFormExpanded);
  };

  const closeForm = () => {
    setIsFormExpanded(false);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Replace with your actual EmailJS configuration
      await emailjs.send('your_service_id', 'your_template_id', formData, 'your_user_id');
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setIsFormExpanded(false);
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="carousel-container">
      <Carousel
        infiniteLoop
        showStatus={false}
        showArrows
        interval={3000}
        stopOnHover
        showThumbs={false}
        autoPlay
        showIndicators={false}
      >
        {[hero1, hero2, hero3].map((imgSrc, index) => (
          <div key={index}>
            <img src={imgSrc} className="img-height" alt={`hero-${index + 1}`} />
          </div>
        ))}
      </Carousel>

      {/* Universal Floating Connect Button */}
      <button
        className={`connect-expert-button ${isFormExpanded ? 'form-open' : ''}`}
        onClick={toggleForm}
        type="button"
      >
        <i className={`fa ${isFormExpanded ? 'fa-times' : 'fa-comments'}`}></i>
        <span className="button-text-desktop">Connect with Expert</span>
      </button>

      {/* Form Overlay */}
      <div 
        className={`form-overlay ${isFormExpanded ? 'active' : ''}`}
        onClick={closeForm}
      ></div>

      {/* Universal Expandable Form */}
      <div className={`designer-form modern-style ${isFormExpanded ? 'form-expanded' : ''}`}>
        <button className="form-close-button" onClick={closeForm} type="button">
          <i className="fa fa-times"></i>
        </button>
        
        <div className="form-content">
          <div className="form-header">
            <div className="icon-wrapper">
              <i className="fa fa-user-circle form-icon"></i>
            </div>
            <h4>Connect with Expert</h4>
            <p>Transform your space today</p>
            <div className="header-divider"></div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <button type="submit" className="cta-button">
              <span className="button-text">Get Free Consultation</span>
              <i className="fa fa-arrow-right button-arrow"></i>
            </button>
          </form>

          <div className="form-footer">
            <p>Free consultation • Quick response</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderCarousel;
